import * as React from 'react';
import {
  SafeAreaView, StyleSheet, View, Text,
} from 'react-native';
import { Avatar, Drawer } from 'react-native-paper';
import { useSelector, useDispatch } from 'react-redux';
import * as Linking from 'expo-linking';
import userActions from '../actions/userActions';
import APMStyles from '../styles';
import Theme from '../constants/Theme';

function CustomDrawerContent(props) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  // console.log(user);

  return (
    <SafeAreaView style={styles.container}>

      <View style={styles.userImg}>
        {
          user && user.attributes.picture
            ? (
              <Avatar.Image
                size={64}
                source={{ uri: user.attributes.picture }}
                theme={Theme.avatar}
              />
            ) : <Avatar.Icon size={64} icon="account-circle-outline" color="white" theme={Theme.avatar} />
        }
        {user && <Text>{user.username}</Text>}
      </View>

      <Drawer.Section>
        <Drawer.Item
          label="HOME"
          icon="home"
          onPress={() => { props.navigation.navigate('Home'); }}
          testID="home-drawer-item"
        />
        {user
          ? (
            <>
              <Drawer.Item
                label="PROFILE"
                icon="account-outline"
                onPress={() => { props.navigation.navigate('Profile'); }}
                testID="profile-drawer-item"
              />
              <Drawer.Item
                label="LOGOUT"
                icon="logout"
                onPress={() => {
                  props.navigation.reset({
                    index: 0,
                    routes: [{ name: 'Home' }],
                  });
                  dispatch(userActions.logout());
                }}
                testID="logout-drawer-item"
              />
            </>
          ) : (
            <>
              <Drawer.Item
                label="LOGIN"
                icon="login"
                onPress={() => { props.navigation.navigate('Login'); }}
                testID="login-drawer-item"
              />
            </>
          )}
        <Drawer.Item
          label="APMBARRACKS.COM"
          icon="open-in-new"
          onPress={() => Linking.openURL('https://apmbarracks.com')}
        />
      </Drawer.Section>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: APMStyles.colors.background,
  },
  userImg: {
    alignItems: 'center',
    paddingVertical: 40,
  },
});

export default CustomDrawerContent;
